import React, { useCallback, useContext, useState } from 'react';
import { Menu, MenuItem, IconButton, ListItemIcon, SvgIcon } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import { ReactComponent as EditIcon } from 'assets/icons/Edit.svg';
import { ReactComponent as RemoveIcon } from 'assets/icons/Remove.svg';
import { actions } from 'store';
import { useDispatch } from 'react-redux';
import { alerts, ticketStatuses } from 'keys';
import { TicketContext } from './TicketContext';
import { toast } from 'react-toastify';
import { toastConfig } from 'config';

const TicketMessageMenu = (props) => {
    let { id, content, image, status } = props
    const { setMessageId, setImage, setMessage, ticket: ticketRes } = useContext(TicketContext)

    const ticket = ticketRes.data

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const dispatch = useDispatch()

    const handleClick = useCallback((event) => {
        setAnchorEl(event.currentTarget)
    }, [])

    const handleClose = useCallback(() => {
        setAnchorEl(null)
    }, [])

    const actionValidation = useCallback(() => {
        if (ticket.status == ticketStatuses.TO_BE_DEVELOPED ||
            ticket.status == ticketStatuses.CLOSE) {
            toast.error('לא ניתן לערוך הודעה בפנייה סגורה או לפיתוח', toastConfig)
            return false
        }
        return true
    }, [ticket])

    const handleDelete = useCallback(() => {
        if (!actionValidation()) return
        dispatch(actions.setAlerts({
            key: alerts.removeTicketMessage,
            value: { open: true, props: id }
        }))
        handleClose()
    }, [id, ticket])

    const handleEdit = useCallback(() => {
        if (!actionValidation()) return
        setMessage(content)
        setImage(image)
        setMessageId(id)
        handleClose()
    }, [id, content, image, ticket])

    return (
        <div>
            <IconButton
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <MoreVert />
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={handleDelete}>
                    <ListItemIcon>
                        <SvgIcon component={RemoveIcon} inheritViewBox />
                    </ListItemIcon>
                    {"מחיקה"}
                </MenuItem>
                <MenuItem onClick={handleEdit}>
                    <ListItemIcon>
                        <SvgIcon component={EditIcon} inheritViewBox />
                    </ListItemIcon>
                    {"עריכה"}
                </MenuItem>
            </Menu>
        </div>
    );
}

export default TicketMessageMenu 
